import { ReactElement, ReactNode } from 'react';
import { container } from './style.css';

export function OverflowContainer({
  children,
  title,
}: {
  children: ReactNode;
  title?: string;
  warp?: boolean;
}): ReactElement {
  return (
    <div className={container} title={title}>
      {children}
    </div>
  );
}
